import nxModule from 'nxModule';
import $ from 'jquery';
import systemPropertyService from '../../../../react/system/systemPropertyService';

const templateUrl = require('./file-upload-new.template.html');
nxModule.component('fileUploadNew', {
  templateUrl,
  bindings: {
    'onFilesAdded': '&',
    'validate': '<',
    'maxSize': '<',
    'ngDisabled': '<',
    'multiple': '<',
    'enableWebcam': '<'
  },
  controller: function () {
    const that = this;
    that.webcamVisible = false;
    that.invalidFiles;

    that.$onInit = () => {
      const systemPropertyMaxSize = that.getMaxSize();
      const baseValidate = that.validate || {};
      const validateMax = baseValidate.size && baseValidate.size.max;
      const resolvedMax = that.maxSize || systemPropertyMaxSize || validateMax || '1MB';

      that.resolvedValidate = {
        ...baseValidate,
        size: {
          max: resolvedMax
        }
      };
    };

    that.getMaxSize = () => {
      const maxSizePropertyValue = systemPropertyService.getProperty('FILE_MAX_UPLOAD_SIZE_IN_MB');
      if (!maxSizePropertyValue) {
        return maxSizePropertyValue;
      }
      return parseFloat(maxSizePropertyValue) ? `${parseFloat(maxSizePropertyValue)}MB` : null;
    };

    const modalElement = () =>
      $('.file-upload-new__modal').find('.modal');

    that.showWebcam = e => {
      e.stopPropagation();
      e.preventDefault();
      that.webcamVisible = true;

      requestAnimationFrame(() => {
        modalElement().modal('show');
        modalElement().on('hidden', () => {
          that.webcamVisible = false;
        });
      });

    };

    that.hideWebcam = () => {
      modalElement().modal('hide');
      that.webcamVisible = false;
      that.uploadForm.$setPristine();
      that.uploadForm.$setUntouched();
    };

    that.onPhotoTaken = blob => {
      that.hideWebcam();

      blob.name = 'cameraPicture';
      that.addFiles([blob]);
    };

    that.addFiles = files => {
      that.onFilesAdded({files, });
    };
  }
});
